import { Injectable } from '@angular/core';
interface DiffResult {
  added?: any;
  removed?: any;
  changed?: any;
}
@Injectable({
  providedIn: 'root'
})

export class ViewSummaryJsonTransformService {

  constructor() { }
  transformInputToSummarySections(input: any, notAllowedSections: string[], metaData: any): { summarySections: any[], lookupCdList: string[] } {
    const summarySectionsList: any[] = [];
    const lookupCdList: string[] = [];

    Object.keys(input).forEach(sectionKey => {
        if (!notAllowedSections.includes(sectionKey)) {
            const sectionData = input[sectionKey];
            const sectionMetaData = metaData[sectionKey] || {};
            const section: any = {
                titleWithIcon: null,
                titleDesc: null,
                icon: this.createIcon(sectionKey),
                heading: this.createLabel(sectionKey),
                key: sectionKey,
                sectionType: Array.isArray(sectionData) ? 'grid' : 'form',
                sectionData: Array.isArray(sectionData)
                    ? this.createGridSectionData(sectionData, sectionMetaData, lookupCdList)
                    : this.createFormSectionData(sectionData, sectionMetaData, lookupCdList)
            };
            summarySectionsList.push(section);
        }
    });

    return { summarySections: summarySectionsList, lookupCdList: Array.from(new Set(lookupCdList)) };
}

private createFormSectionData(data: any, metaData: any, lookupCdList: string[]): any[] {
    return Object.keys(metaData).map(key => {
        const fieldMetaData = metaData[key] || {};
        const value = data[key] !== undefined ? data[key] : null;
        const pipeValue = this.getPipeValue(fieldMetaData);
        
        if (pipeValue) {
            lookupCdList.push(pipeValue);
        }

        return {
            label: this.createLabel(key),
            value: value,
            key: key,
            pipe: this.getPipe(fieldMetaData),
            pipeValue: pipeValue,
            showTag: false,
            tagColor: null,
            showBadge: false,
            badgeStatus: null,
            additionalValue: null
        };
    });
}

private createGridSectionData(data: any[], metaData: any, lookupCdList: string[]): any {
  if (data.length === 0) {
      return { listHeader: [], displayData: [] };
  }

  // Create headers dynamically based on keys from the first data item
  const listHeader = Object.keys(data[0]).map(key => ({
      header: this.createLabel(key),
      key: key,
      isVisible: true
  }));

  // Create display data with appropriate pipe and pipeValue
  const displayData = data.map(item => {
      const rowData: any = {};

      listHeader.forEach(header => {
          const fieldMetaData = metaData[header.key] || {};
          const pipeValue = this.getPipeValue(fieldMetaData);

          if (pipeValue) {
              lookupCdList.push(pipeValue);
          }

          rowData[header.key] = {
              value: item[header.key] || null,
              pipe: this.getPipe(fieldMetaData),
              pipeValue: pipeValue,
              key: header.key
          };
      });

      return rowData;
  });

  return { listHeader, displayData };
}


private getPipe(fieldMetaData: any): string | null {
    if (fieldMetaData.isCurrency) {
        return 'CurrencyFormat';
    } else if (fieldMetaData.lookupCd) {
        return 'technicalTranslate';
    }
    return null;
}

private getPipeValue(fieldMetaData: any): string {
    return fieldMetaData.lookupCd || '';
}

private createIcon(sectionKey: string): string | null {
    const iconMap: { [key: string]: string } = {
        policyDetails: 'policy',
        listOfClients: 'users',
        eventDetails: 'event',
        hospitalizationDetails: 'hospital',
        medicalDetails: 'medical'
    };
    return iconMap[sectionKey] || null;
}

private createLabel(key: string): string {
    return key.replace(/([A-Z])/g, ' $1').replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
}

private createTitleWithIcon(sectionKey: string): string | null {
    return sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1);
}



  findAndReplaceKeyValue(json: any, targetKey: string, newValue: any): any {
    for (const key in json) {
      if (json.hasOwnProperty(key)) {
        if (key === targetKey) {
          // Convert numeric strings to numbers
          if (typeof newValue === 'string' && !isNaN(Number(newValue))) {
            json[key] = Number(newValue);
          } else {
            json[key] = newValue;
          }
        } else if (typeof json[key] === 'object' && json[key] !== null) {
          this.findAndReplaceKeyValue(json[key], targetKey, newValue); // Recursive call for nested objects
        }
      }
    }
    return json; // Return the modified JSON object
  }
  
   
  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }
  
  compareArrays(arr1: any[], arr2: any[]): boolean {
    if (arr1.length !== arr2.length) return false;
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();
    return sortedArr1.every((value, index) => {
      if (this.isObject(value) || Array.isArray(value)) {
        return this.compareJson(value, sortedArr2[index]).changed === undefined;
      } else {
        return value === sortedArr2[index];
      }
    });
  }
  
  compareJson(original: any, modified: any): DiffResult {
    const result: DiffResult = {};
  
    // Check keys in original
    for (const key in original) {
      if (!(key in modified)) {
        result.removed = result.removed || {};
        result.removed[key] = original[key];
      } else {
        const originalValue = original[key];
        const modifiedValue = modified[key];
  
        if (this.isObject(originalValue) && this.isObject(modifiedValue)) {
          const deepDiff = this.compareJson(originalValue, modifiedValue);
          if (Object.keys(deepDiff).length > 0) {
            result.changed = result.changed || {};
            result.changed[key] = deepDiff;
          }
        } else if (Array.isArray(originalValue) && Array.isArray(modifiedValue)) {
          if (!this.compareArrays(originalValue, modifiedValue)) {
            result.changed = result.changed || {};
            result.changed[key] = { original: originalValue, modified: modifiedValue };
          }
        } else if (originalValue !== modifiedValue) {
          result.changed = result.changed || {};
          result.changed[key] = { original: originalValue, modified: modifiedValue };
        }
      }
    }
  
    // Check keys in modified but not in original
    for (const key in modified) {
      if (!(key in original)) {
        result.added = result.added || {};
        result.added[key] = modified[key];
      }
    }
  
    return result;
  }   
}
